import {Nullable} from "./Nullable";

export interface RequestState {
    error: null | any
    isFetching: boolean,
    lastRequestSuccess: number
}

export interface RequestStateProp {
    request: RequestState
}

export const getRequestStateSuccess = ( isFetching: boolean = false ): RequestState => ({
    error: null,
    isFetching: isFetching,
    lastRequestSuccess: Date.now()
});
export const getRequestState = ( isFetching: boolean = false, error: Nullable<Error> = null ): RequestState => ({
    error: error,
    isFetching: isFetching,
    lastRequestSuccess: 0
});

/**
 * shorthand function to create a initial request state for redux reducers
 */
export const getInitialRequestState = (): RequestState => ({
    error: null,
    isFetching: false,
    lastRequestSuccess: 0
});

/**
 * shorthand function to create a request state for redux observable async functions, when starting the api request
 * to be used in redux reducers
 */
export function startFetchingRequestState(): RequestState {
    return {
        isFetching: true,
        lastRequestSuccess: 0,
        error: null
    };
}
/**
 * shorthand function to create a request state for redux observable async functions, when the api request was successful
 * to be used in redux reducers
 */
export function successFetchingRequestState(): RequestState {
    return {
        isFetching: false,
        lastRequestSuccess: Date.now(),
        error: null
    };
}

/**
 * shorthand function to create a request state for redux observable async functions, when the api request failed
 * to be used in redux reducers
 */
export function errorFetchingRequestState( error: any ): RequestState {
    return {
        isFetching: false,
        lastRequestSuccess: 0,
        error: error
    };
}